import * as yup from 'yup'

import {
  GCP_PROJECT_ID_DUPLICATION,
  GCP_PROJECT_ID_VALIDATION
} from 'components/common/mapped-entities/gcp/authentication/gcp-validation-utils'
import { type TeamExternalIntegrationGcp } from 'types/api/status-checks/status-check'

export type GcpAuthenticationIds = {
  projectId: string
  serviceAccountId: string
}

export function getGcpNewAuthFormSchema(
  integrations: TeamExternalIntegrationGcp[]
) {
  const integrationsSet = new Set(
    integrations.map(({ domain }) => domain.toUpperCase())
  )

  return yup.object().shape({
    projectId: yup
      .string()
      .required()
      .matches(GCP_PROJECT_ID_VALIDATION.regex, {
        message: GCP_PROJECT_ID_VALIDATION.message
      })
      .test('not-duplicate', GCP_PROJECT_ID_DUPLICATION.message, (value) =>
        GCP_PROJECT_ID_DUPLICATION.test(value, integrationsSet)
      ),
    serviceAccountId: yup.string().required()
    // TODO: replace with validation when known
    // .matches(GCP_PROJECT_ID_VALIDATION.regex, {
    //   message: GCP_PROJECT_ID_VALIDATION.message
    // })
  })
}
